import { FC, useState, ReactElement, useEffect } from 'react';
import './style.scss';

interface Props {
  id?: string;
  label: string;
  desc?: string;
  value?: any;
  valueContent?: ReactElement;
  content: ReactElement;
  type?: string;
  vtype?: string;
  contentView?: boolean;
  foldViewType?: string;
  foldBtn?: boolean;
  foldBtnText?: any;
  foldBtnClickEvent?: (id: string, status: string) => void;
  labelStyleDef?: React.CSSProperties;
  styleDef?: React.CSSProperties;
}

const TitleContent: FC<Props> = ({
  id = '',
  content,
  label,
  valueContent,
  value,
  desc,
  labelStyleDef,
  styleDef,
  type,
  vtype,
  contentView = true,
  foldViewType,
  foldBtn,
  foldBtnText = [],
  foldBtnClickEvent,
}) => {
  const [viewState, setViewState] = useState({ active: contentView ? '_active' : '' });
  const viewContent = () => {
    viewState.active === '' ? setViewState({ active: '_active' }) : setViewState({ active: '' });
    if (foldBtnClickEvent) foldBtnClickEvent(id, viewState.active);
  };
  useEffect(() => {
    contentView ? setViewState({ active: '_active' }) : setViewState({ active: '' });
  }, [contentView]);

  const foldDiv = () => {
    let div: any = <></>;
    if (foldBtn) {
      div = (
        <div className="_fold">
          <div
            className={viewState.active === '' ? '_btn_div' : '_btn_div _d_btn'}
            onClick={viewContent}
          >
            <div className="_btn"></div>
          </div>
        </div>
      );

      if (foldViewType === 'type2') {
        div = (
          <div className="_fold">
            <div
              className={viewState.active === '' ? '_text_btn_div' : '_text_btn_div _d_btn'}
              onClick={viewContent}
            >
              <div className="_text">{viewState.active === '' ? '상세 보기' : '닫기'}</div>
              <div className="_btn"></div>
            </div>
          </div>
        );
      }
    }
    return div;
  };
  return (
    <div className={['_title_content_detail_box_layout', vtype].join(' ')} style={styleDef}>
      <div className="_top">
        <div className="_label_div">
          <div className="_label" style={labelStyleDef}>
            {label}
          </div>
          {foldDiv()}
        </div>
        {value ? <div className="_value_div">{value}</div> : ''}
        {valueContent ? <div className="_value_html_div">{valueContent}</div> : ''}
        {desc ? <div className="_desc_div _ft_ct_t3">{desc}</div> : ''}
      </div>
      <div className={['_content_div', viewState.active].join(' ')}>
        <div className={['_content', type].join(' ')}>{content}</div>
      </div>
    </div>
  );
};

export default TitleContent;
